import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const CountryDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data, confirmLoading} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Country"
            okText="Save"
            onOk={onCreate}
            confirmLoading={confirmLoading}
            onCancel={onCancel}
            
            >

            <Form layout="vertical">
              <Form.Item label="Country Name">
                {getFieldDecorator('countryName', {
                 initialValue: data.countryName,
                  rules: [{ required: true, message: 'Please input the Country Name!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default CountryDialogForm;
